import { TEXTS } from "../constants";
import styles from "./Schedules.scss";
import { ScheduleTime } from "./ScheduleTime";

export function SchedulesInfo({ now }: { now: Date }) {
  return (
    <div className={styles.container}>
      <div className={styles.description}>
        <p>{TEXTS.SCHEDULES_INFO.DESCRIPTION}</p>
        <p className={styles.maintenanceNotice}>
          <strong>{TEXTS.SCHEDULES_INFO.MAINTENENCE_NOTICE}</strong>
        </p>
      </div>
      <ScheduleTime
        className={styles.currentTime}
        date={now}
        label="Now"
        align="end"
        size="large"
      />
    </div>
  );
}
